import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
export function AcceptInvitePage() {
  return <div className="min-h-screen bg-background flex items-center justify-center p-6" data-id="element-5348">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md" data-id="element-5349">
        <div className="flex flex-col items-center mb-8" data-id="element-5350">
          <Link to="/" className="flex items-center gap-2 mb-6" data-id="element-5351">
            <span className="text-2xl font-bold tracking-tight text-textMain" data-id="element-5352">
              Booker
            </span>
            <div className="w-2 h-2 rounded-full bg-primary mt-1" data-id="element-5353"></div>
          </Link>
          <h1 className="text-2xl font-bold text-textMain mb-2" data-id="element-5354">
            You've been invited
          </h1>
          <p className="text-textMuted text-sm text-center" data-id="element-5355">
            Join your team to collaborate on bookings and tours.
          </p>
        </div>

        <div className="bg-surface border border-border rounded-xl p-6 shadow-xl mb-6" data-id="element-5356">
          <div className="bg-background border border-border rounded-lg p-4 mb-6 flex items-center gap-4" data-id="element-5357">
            <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-lg" data-id="element-5358">
              W
            </div>
            <div className="flex-1" data-id="element-5359">
              <h3 className="font-semibold" data-id="element-5360">The Wildwoods</h3>
              <p className="text-sm text-textMuted" data-id="element-5361">Invited by Mark Johnson</p>
            </div>
            <span className="px-2 py-1 bg-surface border border-border rounded text-xs font-medium text-textMuted" data-id="element-5362">
              Member
            </span>
          </div>

          <form className="space-y-4 mb-6" onSubmit={e => e.preventDefault()} data-id="element-5363">
            <div data-id="element-5364">
              <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5365">
                Full Name
              </label>
              <input type="text" className="w-full px-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" placeholder="Jane Doe" data-id="element-5366" />
            </div>
            <div data-id="element-5367">
              <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5368">
                Email
              </label>
              <input type="email" disabled value="jane@thewildwoodsband.com" className="w-full px-4 py-2.5 bg-background/50 border border-border rounded-lg text-sm text-textMuted cursor-not-allowed" data-id="element-5369" />
            </div>
            <div data-id="element-5370">
              <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5371">
                Password
              </label>
              <input type="password" className="w-full px-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" placeholder="••••••••" data-id="element-5372" />
            </div>
            <button className="w-full py-2.5 mt-2 bg-primary text-background rounded-lg font-medium hover:bg-primaryHover transition-colors shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-5373">
              Join workspace
            </button>
          </form>

          <div className="relative mb-6" data-id="element-5374">
            <div className="absolute inset-0 flex items-center" data-id="element-5375">
              <div className="w-full border-t border-border" data-id="element-5376"></div>
            </div>
            <div className="relative flex justify-center text-xs" data-id="element-5377">
              <span className="bg-surface px-2 text-textMuted" data-id="element-5378">Or</span>
            </div>
          </div>

          <button className="w-full py-2.5 bg-background border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors flex items-center justify-center gap-2" data-id="element-5379">
            <Users className="w-4 h-4 text-textMuted" data-id="element-5380" />
            Link existing account
          </button>
        </div>
      </motion.div>
    </div>;
}